import { useContext } from "react";
import { FlexGrow } from "./FlexBox";
import SimpleDatePicker from "./SimpleDatePicker";
import { SemesterContext } from "../context/SemesterContext";
import dayjs from "dayjs";

interface Props {
  startDate: any;
  setStartDate: any;
  endDate: any;
  setEndDate: any;
  
}
export const CustomDateRangePicker = (props: Props) => {
  const { startDate, endDate, setStartDate, setEndDate } = props;
  const semesterContext = useContext(SemesterContext);

  return (
    <>
      {" "}
      <div style={{ marginBottom: 20, fontWeight: "bold" }}>
        {" "}
        Select the start date and target completion date for the milestone
      </div>
      <FlexGrow style={{ display: "flex", width: "100%", gap: 15 }}>
        <FlexGrow>
          {" "}
          <SimpleDatePicker
            defaultStartDate={semesterContext.selectedSemester.start_date}
            defaultEndDate={semesterContext.selectedSemester.end_date}
            setDate={setStartDate}
            date={dayjs(new Date(startDate)?.toISOString()?.split('T')[0])}
            title="Start Date"
          />
        </FlexGrow>
        <FlexGrow>
          {" "}
          <SimpleDatePicker
            defaultStartDate={semesterContext.selectedSemester.start_date}
            defaultEndDate={semesterContext.selectedSemester.end_date}
            setDate={setEndDate}
            date={dayjs(new Date(endDate)?.toISOString()?.split('T')[0])}
            title="End Date"
          />
        </FlexGrow>
      </FlexGrow>
    </>
  );
};
